import React from 'react';
import ExpandHeader from '../../misc/expand-header/expandHeader'; // eslint-disable-line
import AttendeeInfos from './attendee-infos/attendeeInfos';


export default function ConfirmStep({config}) {
    const { title } = config.confirmation_detail.ticket_detail.header;
    const { attendees } = config.confirmation_detail;

    const [showMore, setShowMore] = React.useState(attendees.map(attendee => {
        return false;
    }));

    return (
        <div className='neo-confirm-step'>
            <h1 className='neo-rate-step-rates-title'>{title}</h1>
                {attendees.map((attendee, index) => <AttendeeInfos key={index} index={index} attendee={attendee} showMore={showMore} setShowMore={setShowMore}/>)}
        </div>
    )
}